import React from 'react'
import { useSelector } from 'react-redux'
import ProgramSurveyWithGraphModule from './components/ProgramSurveyWithGraphModule'
import Feedback from './components/Feedback'
import NumberOfMeetings from './components/NumberOfMeetings'
import SobrietyCheckup from './components/SobrietyCheckup'
import { intersection } from 'lodash'

export default function OutcomesTab() {
  const { program_survey_responses, feeback_responses=[], number_of_meetings_responses=[], sobriety_checkup_responses=[] } = useSelector(state=>state.outcomes)
  const { organization, resident, permissions, config } = useSelector(state=>state)
  return (
    <div>
      {
        intersection(permissions, ["export_csv"]).length > 0 && !config.isStaffApp &&
        <div className="text-right pb-3 pr-2">
          <a href={`/organizations/${organization.name}/residents/${resident.id}/outcomes.csv`} className="btn btn-primary">Export Data</a>
        </div>
      }
      <div>
        {
          program_survey_responses.map((survey, index)=>(
            <ProgramSurveyWithGraphModule 
              key={index}
              {...survey }
              resident={resident}
              isStaffApp={config.isStaffApp}
              organizationName={organization.name}
              residentId={resident.id}/>
          ))
        }
        { feeback_responses.length > 0 && <Feedback submissions={feeback_responses}/>}
        { number_of_meetings_responses.length > 0 && <NumberOfMeetings submissions={number_of_meetings_responses}/>}
        { sobriety_checkup_responses.length > 0 && <SobrietyCheckup submissions={sobriety_checkup_responses}/>}
      </div>
    </div>
  )
}